<template>
  <div class="ml-8">
   
    <h1>Admin Page</h1>

    <div> <router-link class="m4u_text--text" to="/admininvitation">Admin Invitation</router-link></div>
    <div> <router-link class="m4u_text--text" to="/quickconnectmanagement">Manage Quick Connect Questions</router-link></div>
    <div> <router-link class="m4u_text--text" to="/adminmessage">Add A System Message</router-link></div>
    <div>
      <h2>User Counts</h2>
      <div class="ml5">
      <v-row class="m4u_tertiary mt-3">Standard Monthly Subscribers: {{type1}}</v-row>
      <v-row  class="message_background">Charter Member 2 (10 free invitations): {{type2}}</v-row>
      <v-row  class="m4u_tertiary">Charter Member 3 (5 free invitations): {{type3}}</v-row>
      <v-row  class="message_background">Charter Member 4 (no free invitations): {{type4}}</v-row>
      <v-row  class="m4u_tertiary">Total potential charter members: {{totalPotentialCharters}}</v-row>
      <v-row  class="message_background">Admin users: {{type6}}</v-row>
      <v-row  class="message_background">Charter invitations sent - not yet accepted: {{unUsedInvitations}}</v-row>
      <v-row class="primary m4u_text--text">Total Current Memories For Us Users: {{totalCurrentUsers}}</v-row>
      </div>
    </div>
 
</div>

</template>

<script>
import EventService from '@/services/EventService.js'; 

export default {
  name: "adminpage",

  data() {
    return {

      charterCounts: '',
      userCounts: '',
      type1: 0,
      type2: 0,
      type3: 0,
      type4: 0, 
      type6: 0,
      usedCounts: '',
      usedType3: 0,
      userType4: 0,
      openCounts: '',
      openType3: 0,
      openType4: 0,
      totalPotentialCharters: 0,
      totalCurrentUsers: 0,
      unUsedInvitations: 0,
      usedInvitations: 0,
      openInvitations: 0,

    };
  },

  mounted() {
      this.getUserCountsSubType();
      // this.charterInvitationsCount();
      // this.calcUsers();
  },
  methods: {
    async getUserCountsSubType() {
      await EventService.getUserCountsSubType()
      .then(
        (userCounts => {

          for (var i = 0; i < userCounts.length; i++)
            {
                var type = userCounts[i];
                if (type.UserSubType === 1)
                {
                   this.type1 = type.userCount
 //                  console.log('type 1 user count is: ', this.type1)
                }
                if (type.UserSubType === 2)
                {
                   this.type2 = type.userCount
 //                  console.log('type 2 user count is: ', this.type2)
                }
                if (type.UserSubType === 3)
                {
                   this.type3 = type.userCount
 //                  console.log('type 3 user count is: ', this.type3)
                }
                if (type.UserSubType === 4)
                {
                   this.type4 = type.userCount
//                   console.log('type 4 user count is: ', this.type4)
                }
                if (type.UserSubType === 6)
                {
                   this.type6 = type.userCount
//                   console.log('type 6 user count is: ', this.type6)
                }
            }
          this.$set(this, "userCounts", userCounts);
//          console.log('userCounts is: ', this.userCounts)
        })
        .bind(this))
        .then(() => {
          this.charterInvitationsCount();
        })
        .then(() => {
          this.calcUsers();
        })
    },

    async charterInvitationsCount() {

        //get the open invitations
      await EventService.charterInvitationsOpenCount()
      .then(
        (counts => {

          this.unUsedInvitations = counts[0].userCount
          this.$set(this, "openCounts", counts);
//          console.log('openCounts is: ', this.openCounts)
        }).bind(this))
    },

    async calcUsers() {
//      console.log('this.type2 is: ', this.type2)
      const potential3 = this.type2 * 10
//      console.log('potential3 is: ', potential3)
      const potential4 = this.type3 * 5
//      console.log('potential4 is: ', potential4)
      this.totalPotentialCharters = this.type2 + potential3 + potential4
//      console.log('totalPotential=this.type2 + potential3 + potential4 : ', this.type2, potential3, potential4, '=', this.totalPotentialCharters)
      this.totalCurrentUsers = this.type1 + this.type2 + this.type3 + this.type4 + this.type6
      this.usedInvitations = this.usedType3 + this.usedType4
//      console.log('usedInvitations is: ', this.usedType3, ' + ', this.usedType4, ' = ', this.usedInvitations)
      this.openInvitations = this.openType3 + this.openType4
//      console.log('openInvitations is: ', this.openInvitations)
      const sentInvitations = this.usedInvitations + this.openInvitations
//      console.log('sent invitations is: ', sentInvitations)
//      this.unUsedInvitations = (this.totalPotentialCharters) - (this.sentInvitations)
    }
  }
}

</script>
<style lang="scss" scoped>
body {
  background: green;
}
.org-description {
  margin-top: 50px;
}
</style>
